import { useEffect, useRef, useState } from 'react'

export function Scanner({ onScan, onCancel }: { onScan: (value: string) => void; onCancel: () => void }) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [error, setError] = useState('')
  useEffect(() => {
    let controls: { stop: () => void } | undefined
    let active = true
    let delivered = false
    import('@zxing/browser').then(({ BrowserQRCodeReader }) => {
      const reader = new BrowserQRCodeReader()
      if (active && videoRef.current) {
        reader.decodeFromConstraints({ video: { facingMode: 'environment' } }, videoRef.current, (result) => {
          if (active && !delivered && result) { delivered = true; controls?.stop(); onScan(result.getText()) }
        }).then((value) => { controls = value; if (!active || delivered) controls.stop() }).catch(() => { if (active) setError('No se pudo abrir la cámara. Revisa el permiso o ingresa el código manualmente.') })
      }
    }).catch(() => setError('No se pudo cargar el lector QR.'))
    return () => { active = false; controls?.stop() }
  }, [onScan])
  return <div className="scanner">
    <video ref={videoRef} muted playsInline aria-label="Vista de la cámara para escanear QR" />
    {error && <p className="notice notice--error">{error}</p>}
    <button className="button button--ghost" onClick={onCancel}>Cancelar</button>
  </div>
}
